<template>
    <div class="fr btn-text">
        <span v-if="published || questionsCountValue > 0">
            <button v-show="published" v-on:click="toggleDraft" v-bind:class="{'btn-loading': loading}" class="btn btn-text btn-text--accent width-auto-min f-s-3" type="button">
                {{ trans('Unpublish Quiz') }}
                <div v-if="loading" class="loader">
                    <div class="chartdonut chartdonut_animation--rotate-tiny chartdonut--tiny">
                        <svg class="i-stroke-accent" width="24" height="24"><g><circle class="icon" cx="50%" cy="50%" r="10" stroke-width="2" fill="none" stroke-dashoffset="5"></circle></g></svg>
                    </div>
                </div>
            </button>
            <button v-show=" ! published" v-on:click="togglePublished" v-bind:class="{'btn-loading': loading}" class="btn btn-text btn-text--accent width-auto-min f-s-3" type="button">
                {{ trans('Publish Quiz') }}
                <div v-if="loading" class="loader">
                    <div class="chartdonut chartdonut_animation--rotate-tiny chartdonut--tiny">
                        <svg class="i-stroke-accent" width="24" height="24"><g><circle class="icon" cx="50%" cy="50%" r="10" stroke-width="2" fill="none" stroke-dashoffset="5"></circle></g></svg>
                    </div>
                </div>
            </button>
        </span>
        <span v-else class="tooltip animate">
            <button class="btn btn-text btn-text--muted-simple width-auto-min f-s-3" type="button" disabled>{{ trans('Publish Quiz') }}</button>
            <span class="tooltip-content tooltip-item tooltip--top">{{ trans('Add at least one question before publishing this quiz.') }}</span>
        </span>
    </div>
</template>
<script>
import { quizPublishLink } from '../routes';
import { EventBus } from '../event-bus.js';

export default {
    props: {
        quiz: {
            type: Object
        },
        questionsCount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            published: this.quiz.status === 'published',
            loading: false,
            questionsCountValue: this.questionsCount
        }
    },
    created() {
        EventBus.$on('quiz-questions:count-changed', this.onQuestionsCountChanged);
    },
    beforeDestroy() {
        EventBus.$off('quiz-questions:count-changed', this.onQuestionsCountChanged);
    },
    methods: {
        onQuestionsCountChanged(count) {
            this.questionsCountValue = count;
        },
        togglePublished() {
            this.loading = true;
            window.axios
                .put(quizPublishLink(this.quiz))
                .then(() => {
                    this.loading = false;
                    this.published = true;
                })
                .catch(({response}) => {
                    this.loading = false;
                    this.$toast.danger(response.data.message);
                });
        },
        toggleDraft() {
            this.loading = true;
            window.axios
                .delete(quizPublishLink(this.quiz))
                .then(() => {
                    this.loading = false;
                    this.published = false;
                });
        },
    }
}
</script>
